import { render } from "./FinishResignation.vue?vue&type=template&id=c69cb6a0"
import script from "./FinishResignation.vue?vue&type=script&lang=js"
export * from "./FinishResignation.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__